import React, {useState, useEffect} from "react";
import { siteById } from "../../services/MetadataService"
import LocationMap from "../LocationMap"

 const FloorMapView = (props) => {
	const [floorMapFile, setFloorMapFile] = useState()
	const [site, setSite] = useState()

	useEffect(() => {
		if (props.siteId) {
			siteById(props.siteId).then(response => {
				setSite(response)
			})
		}
	}, [])

	if (!site) return null;

	return (
		<div className="floor-map">
			{
				props.floor_map ?
				<div className="floor-map-preview">If we have a floor map it goes here</div> :
				<div className="site-location-map">
					<LocationMap sites={[site]} zoomOverride={10} />
				</div>
			}
		</div>
		
	)
}

export default FloorMapView;